import { useCallback, useRef } from 'react';

import cn from 'classnames/bind';
import { useClosableModal } from 'hooks';
import { CSSTransition } from 'react-transition-group';

import s from './Popup.module.scss';

const cx = cn.bind(s);

const Popup = ({
  children, isOpen, className, onClose, ...attrs
}) => {
  const close = useCallback(() => {
    onClose?.();
  }, [onClose]);
  useClosableModal({
    onUrlChanged: close,
    onClose: close,
    shouldLockWindow: true,
    isActive: isOpen,
  });
  const handleContainerClick = (ev) => {
    if (ev.target === ev.currentTarget && onClose) {
      onClose();
    }
  };
  const containerRef = useRef();
  return (
    <CSSTransition
      nodeRef={containerRef}
      in={isOpen}
      mountOnEnter
      unmountOnExit
      timeout={200}
      classNames={{ ...s }}
    >
      <div
        ref={containerRef}
        data-testid="popup-container"
        className={cx(className, 'popup-container')}
        {...attrs}
        role="dialog"
      >
        <div data-testid="popup-content" className={cx('popup-content')} onClick={handleContainerClick}>
          {children}
        </div>
      </div>
    </CSSTransition>
  );
};

export default Popup;
